module.exports = __webpack_public_path__ + "img/title1.87deee79.svg";